import {
    LOADING_PLANES,
    SET_ID,
    SET_PLANES,
    SET_DATA_GRUPO,
    SET_GRUPO_PLANES,
    FETCH_GRUPO_BYID,
    FETCH_GRUPO_PLANES,
    SET_DATA_GRUPO_COPY,
    FETCH_PLANES_BYPARAMS,
    FETCH_GRUPO_PLANES_BYID,
    SET_PLANES_DESDE_BUSQUEDA,
    SET_FILTRO_GRUPO_PLANES,
    SET_ID_GRUPO_PLAN,
    RESET_GRUPO_PLANES,
    UPDATE_GRUPO_PLANES_LIST,
    SET_EDITANDO
} from '../actions/types';

const initialState = {
    loadingPlanes: false,
    id: 0,
    planes: [],
    grupoPlanes: { elementos: [], total: 0, page: 1 },
    grupoPorId: {},
    dataGrupo: {},
    dataGrupoCopy: {},
    planesDesdeBusqueda: [],
    grupoPlanesBusqueda: [],
    planesPorParametros: [],
    filtro: {},
    editando: false,
}

const firstGrupo = (payload) => {
    const data = payload?.data ?? payload ?? {};

    if (Array.isArray(data?.paginationGrupoPlanes?.content) && data.paginationGrupoPlanes.content.length > 0) {
        return data.paginationGrupoPlanes.content[0];
    }
    if (Array.isArray(data?.paginationGrupoPlanes?.Content) && data.paginationGrupoPlanes.Content.length > 0) {
        return data.paginationGrupoPlanes.Content[0];
    }
    if (Array.isArray(data?.elementos) && data.elementos.length > 0) return data.elementos[0];
    if (Array.isArray(data?.Elementos) && data.Elementos.length > 0) return data.Elementos[0];
    if (Array.isArray(data?.content) && data.content.length > 0) return data.content[0];
    if (Array.isArray(data?.Content) && data.Content.length > 0) return data.Content[0];

    if (Array.isArray(data?.grupo) && data.grupo.length > 0) return data.grupo[0];
    if (Array.isArray(data?.Grupo) && data.Grupo.length > 0) return data.Grupo[0];

    if (data?.idGrupoPlan || data?.IdGrupoPlan) return data;
    return {};
};

export default function (state = initialState, action) {
    switch (action.type) {
        case LOADING_PLANES:
            return {
                ...state,
                loadingPlanes: action.payload
            };
        case SET_PLANES:
            return {
                ...state,
                planes: action.payload
            };
        case SET_PLANES_DESDE_BUSQUEDA:
            return {
                ...state,
                planesDesdeBusqueda: action.payload
            };
        case SET_ID:
            return {
                ...state,
                id: action.payload
            };
        case FETCH_GRUPO_PLANES:
            const data = action.payload.data;
            let normalized = data;

            if (data && data.paginationGrupoPlanes) {
                const pag = data.paginationGrupoPlanes;
                normalized = {
                    ...pag,
                    elementos: pag.content || pag.Content || [],
                    cantidadTotal: pag.total || pag.Total || 0,
                    cantidadPagina: pag.pageSize || pag.PageSize || 10,
                    // Mapear elementos dentro de content si es necesario
                };
            } else if (data) {
                const elementos =
                    Array.isArray(data?.elementos) ? data.elementos :
                        Array.isArray(data?.Elementos) ? data.Elementos :
                            Array.isArray(data?.content) ? data.content :
                                Array.isArray(data?.Content) ? data.Content : [];
                normalized = {
                    ...data,
                    elementos,
                    total: data?.total ?? data?.Total ?? data?.cantidadTotal ?? data?.CantidadTotal ?? elementos.length,
                    page: data?.page ?? data?.Page ?? data?.numeroPagina ?? data?.NumeroPagina ?? 1
                };
            }

            return {
                ...state,
                grupoPlanes: normalized
            };
        case SET_ID_GRUPO_PLAN:
            return {
                ...state,
                grupoPlanes: { elementos: [], total: 0, page: 1 }
            };
        case SET_GRUPO_PLANES:
            return {
                ...state,
                grupoPlanesBusqueda: action.payload
            };
        case FETCH_GRUPO_PLANES_BYID:
            const dataById = action.payload.data;
            let normalizedById = dataById;

            if (dataById && dataById.planes && dataById.planes.paginationPlanes) {
                const pag = dataById.planes.paginationPlanes;
                normalizedById = {
                    ...pag,
                    elementos: pag.content || pag.Content || [],
                    cantidadTotal: pag.total || pag.Total || 0,
                };
            }
            else if (dataById && dataById.elementos) {
                normalizedById = dataById;
            } else if (dataById && dataById.paginationGrupoPlanes) { // Keep existing logic as fallback
                const pag = dataById.paginationGrupoPlanes;
                normalizedById = {
                    ...pag,
                    elementos: pag.content || pag.Content || [],
                };
            } else if (dataById && (dataById.paginationPlan || dataById.PaginationPlan)) {
                const pag = dataById.paginationPlan || dataById.PaginationPlan;
                const raw = pag.content || pag.Content || [];
                const elementos = raw.map((p) => ({
                    ...p,
                    idPlan: p.idPlan ?? p.IdPlan ?? p.id ?? p.Id,
                    numeroPlan: p.numeroPlan ?? p.NumeroPlan ?? p.numero ?? p.Numero,
                    descripcion: p.descripcion ?? p.Descripcion ?? ''
                }));
                normalizedById = {
                    ...pag,
                    elementos,
                    cantidadTotal: pag.total ?? pag.Total ?? elementos.length
                };
            } else if (dataById && dataById.planes) { // New case: direct 'planes' array or object
                if (Array.isArray(dataById.planes)) {
                    normalizedById = {
                        elementos: dataById.planes
                    }
                } else if (dataById.planes.elementos) {
                    normalizedById = dataById.planes;
                }
            }

            return {
                ...state,
                grupoPorId: normalizedById
            };
        case FETCH_GRUPO_BYID:
            return {
                ...state,
                dataGrupo: firstGrupo(action.payload)
            };
        case SET_DATA_GRUPO:
            return {
                ...state,
                dataGrupo: action.payload
            };
        case SET_DATA_GRUPO_COPY:
            return {
                ...state,
                dataGrupoCopy: action.payload
            };
        case FETCH_PLANES_BYPARAMS:
            return {
                ...state,
                planesPorParametros: action.payload
            };
        case SET_FILTRO_GRUPO_PLANES:
            return {
                ...state,
                filtro: action.payload
            };
        case RESET_GRUPO_PLANES:
            return {
                ...state,
                grupoPlanes: { elementos: [], total: 0, page: 1 }
            };

        case SET_EDITANDO:
            return {
                ...state,
                editando: !!action.payload
            };

        case UPDATE_GRUPO_PLANES_LIST:
            return {
                ...state,
                grupoPlanes: action.payload
            };
        default: return state
    }
}